<template>
    <div class="priority-item queue-queued">
        <div v-if="isRegisteredUser">
            <p class="mb-3">
                <strong class="gap-10px d-flex">
                    <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M2 22C1.45 22 0.979001 21.7947 0.587001 21.384C0.195002 20.9733 -0.000664969 20.4803 1.69779e-06 19.9048V9.42857C1.69779e-06 8.85238 0.196001 8.35895 0.588001 7.94829C0.980001 7.53762 1.45067 7.33263 2 7.33333H3V5.2381C3 3.78889 3.48767 2.5534 4.463 1.53162C5.43833 0.509842 6.61733 -0.000697697 8 7.15587e-07C9.38333 7.15587e-07 10.5627 0.51089 11.538 1.53267C12.5133 2.55445 13.0007 3.78959 13 5.2381V7.33333H14C14.55 7.33333 15.021 7.53867 15.413 7.94933C15.805 8.36 16.0007 8.85308 16 9.42857V19.9048C16 20.481 15.804 20.9744 15.412 21.385C15.02 21.7957 14.5493 22.0007 14 22H2ZM2 19.9048H14V9.42857H2V19.9048ZM8 16.7619C8.55 16.7619 9.021 16.5566 9.413 16.1459C9.805 15.7352 10.0007 15.2422 10 14.6667C10 14.0905 9.804 13.597 9.412 13.1864C9.02 12.7757 8.54933 12.5707 8 12.5714C7.45 12.5714 6.979 12.7768 6.587 13.1874C6.195 13.5981 5.99933 14.0912 6 14.6667C6 15.2429 6.196 15.7363 6.588 16.147C6.98 16.5576 7.45067 16.7626 8 16.7619ZM5 7.33333H11V5.2381C11 4.36508 10.7083 3.62302 10.125 3.01191C9.54167 2.40079 8.83333 2.09524 8 2.09524C7.16667 2.09524 6.45833 2.40079 5.875 3.01191C5.29167 3.62302 5 4.36508 5 5.2381V7.33333Z"
                            fill="#8F6C25"
                        />
                    </svg>
                    {{ translate('Permission Required') }}</strong
                >
            </p>

            <p>{{ translate('Please get permission from the file owner to get access.') }}</p>
        </div>
        <div v-else>
            <p class="mb-2">
                <strong class="gap-10px d-flex">
                    <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M12.9241 12.5641L9.3241 16.1641C9.12121 16.367 8.84603 16.481 8.5591 16.481C8.27217 16.481 7.99699 16.367 7.7941 16.1641C7.59121 15.9612 7.47723 15.686 7.47723 15.3991C7.47723 15.1122 7.59121 14.837 7.7941 14.6341L9.55 12.88H2.08C1.79357 12.88 1.51886 12.7662 1.31632 12.5637C1.11379 12.3611 1 12.0864 1 11.8C1 11.5136 1.11379 11.2389 1.31632 11.0363C1.51886 10.8338 1.79357 10.72 2.08 10.72H9.55L7.7959 8.96409C7.69544 8.86363 7.61575 8.74436 7.56138 8.6131C7.50701 8.48184 7.47903 8.34116 7.47903 8.19909C7.47903 7.91216 7.59301 7.63698 7.7959 7.43409C7.99879 7.2312 8.27397 7.11721 8.5609 7.11721C8.84783 7.11721 9.12301 7.2312 9.3259 7.43409L12.9259 11.0341C13.0265 11.1345 13.1062 11.2539 13.1606 11.3852C13.2149 11.5165 13.2428 11.6573 13.2427 11.7995C13.2425 11.9416 13.2143 12.0823 13.1596 12.2135C13.1049 12.3447 13.0249 12.4639 12.9241 12.5641ZM17.2 2.79999H12.16C11.8736 2.79999 11.5989 2.91377 11.3963 3.11631C11.1938 3.31885 11.08 3.59355 11.08 3.87999C11.08 4.16642 11.1938 4.44112 11.3963 4.64366C11.5989 4.8462 11.8736 4.95999 12.16 4.95999H16.84V18.64H12.16C11.8736 18.64 11.5989 18.7538 11.3963 18.9563C11.1938 19.1589 11.08 19.4336 11.08 19.72C11.08 20.0064 11.1938 20.2811 11.3963 20.4837C11.5989 20.6862 11.8736 20.8 12.16 20.8H17.2C17.6774 20.8 18.1352 20.6103 18.4728 20.2728C18.8104 19.9352 19 19.4774 19 19V4.59999C19 4.1226 18.8104 3.66476 18.4728 3.3272C18.1352 2.98963 17.6774 2.79999 17.2 2.79999Z"
                            fill="#8F6C25"
                        />
                    </svg>

                    {{ translate('Please Log In or Sign Up') }}</strong
                >
            </p>
            <p class="mb-2">{{ translate('Please log in or sign up to move forward.') }}</p>
            <div class="gap-10px d-flex">
                <a title="Login" class="btn btn-success px-4 py-2 font-lg text-white cursor-pointer" @click="clickLoginButton">{{ translate("Log In") }}</a>
              <a title="signup" class="btn btn-success px-4 py-2 font-lg text-white cursor-pointer" @click="clickSignupButton">{{ translate("Sign Up") }}</a>
            </div>
        </div>
    </div>
</template>
<script>
import store from './../../../mixins/store.mixin';
import currentJob from './../../../mixins/current_job.mixin';
import user from '../../../mixins/user.mixin';
import TransFilter from '../../../../mixins/TransFilter.vue';
import {pageStoreMixin} from "../../../../../../../../lib-sat/store/page-store";
import userMixin from "../../../mixins/user.mixin";
import { registerPaymentModalHelper } from '../../../../../../../../lib-sat/user/modal/register_payment_flow/register-payment-modal-helper';

export default {
    name: 'QueueProtected',
    props: {},
    components: {},
  mixins: [store, currentJob, userMixin, pageStoreMixin, TransFilter],
    data() {
        return {};
    },
    mounted: function () {},
    created: function () {},
    methods: {
        clickLoginButton() {
            this.store.userPaymentModal.setSkipPayment(true);
            registerPaymentModalHelper.openLogin();
        },
        clickSignupButton() {
            this.store.userPaymentModal.setSkipPayment(true);
            registerPaymentModalHelper.openRegister();
        },
    },
    computed: {},
};
</script>
<style lang="scss"></style>
